angular.
module("dx.webapp.wordGap", [
	"dx.ui.components.localize",
	"dx.ui.utils",
]);
